import type { LanguageCode as ISOLanguageCode } from 'iso-639-1'
import ISO6391 from 'iso-639-1'

export type LanguageCode = ISOLanguageCode

export const supportedLanguageCodes: LanguageCode[] = ['ca', 'de', 'en', 'es']
export const supportedLanguages = supportedLanguageCodes.map(code => ({
  label: ISO6391.getNativeName(code),
  value: code
}))

export const getNativeName: (code: LanguageCode | string) => string = (
  code: LanguageCode | string
): string => ISO6391.getNativeName(code)
export const getName: (code: LanguageCode | string) => string = (
  code: LanguageCode | string
): string => ISO6391.getName(code)
export const getAllCodes: () => LanguageCode[] = () => ISO6391.getAllCodes()

export type Language = {
  label: string
  value: string
}
